import { render, staticRenderFns } from "./edit_flag_retirado.vue?vue&type=template&id=86a78968"
import script from "./edit_flag_retirado.vue?vue&type=script&lang=js"
export * from "./edit_flag_retirado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports